//引入接口文档
import req from '@/utils/req.js'

//新增时间轴
export function addTimeAxis(params) {
  return req.post("/admin/scheme-time-axis",params);
}

//查一个链的所有时间轴
export function getTimeAxisList(params) {
  return req.get("/admin/scheme-time-axis/getListByRefId",params);
}

//重置（批量删除本次新增的数据）
export function resetTimeAxis(params) {
  return req.post('/admin/scheme-time-axis/reset',params);
}

//保存时批量更新时间轴顺序
export function updateSeq(params) {
  return req.post("/admin/scheme-time-axis/updateSeq", params);
}

//删除单个时间轴
export function deleteTimeAxis(params) {
  return req.delete(`/admin/scheme-time-axis/${params}`);
}

//查一个链的所有时间轴(草稿)
export function getDraftListByRefId(params) {
  return req.get("/admin/scheme-time-axis/getDraftListByRefId",params);
}


//甘特图
export function getGanttTimeAxis(params) {
  return req.get("/admin/scheme/gantt-chart",params);
}

//时间轴图
export function getChartTimeAxis(params) {
  return req.get("/admin/scheme/time-axis-chart",params);
}

//重置草稿数据
export function resetScheme(b,a) {
  // return req.post('/admin/scheme/reset',params);
  return req.post(`/admin/scheme/reset?schemeId=${b}&schemeType=${a}`);
}

//批量调整编链项目时间
export function adjustTime(params) {
  return req.post("/admin/scheme/adjust-time", params);
}

//编链目的新增
export function addSchemeItemPurpose(params) {
  return req.post("/admin/scheme-item-purpose", params)
}

//编链目的更新
export function putSchemeItemPurpose(params) {
  return req.put("/admin/scheme-item-purpose", params)
}

//查询编链目的
export function getPurposeBySchemeId(params) {
  return req.get("/admin/scheme-item-purpose/getNewestBySchemeId", params)
}

// 编链目的删除
export function delSchemeItemPurpose(id) {
  return req.delete(`/admin/scheme-item-purpose/${id}`);
}

//获取患者用药记录
export function getPatientMedicineLog(params) {
  return req.get("/admin/take-drugs-record/getPatientTakeDrugsRecordVOByPatientId", params)
}

//患者用药记录表分页查询
export function pageHistoryDrugLog(params) {
  return req.post("/admin/take-drugs-record/page", params)
}

//一级阶段查询二级阶段
export function getStageByParentId(params) {
  return req.post("/admin/therapy-stage-mapping/list", params)
}

//平台端模板链我的模板方案
export function mySchemeList(params) {
  return req.get("/admin/scheme/mySchemeList", params)
}

//获取模板链要同步到的医生链数据
export function getSchemeSyncDoctorScheme(params) {
  return req.get("/admin/scheme/getSchemeSyncDoctorScheme", params)
}

//编链时间轴数据列表
export function getTimeAxisListByName(params) {
  return req.get("/biz/scheme-time-axis-data/listByName", params)
}

//新增编链时间轴
export function saveTimeAxisData(params) {
  return req.post("/biz/scheme-time-axis-data", params)
}

//根据数据id和方案id和方案类型获取关联列表
export function getListByDataIdAndSchemeIdAndSchemeType(params) {
  return req.get("/biz/scheme-time-axis-data-label/getListByDataIdAndSchemeIdAndSchemeType", params)
}

//查询标签库系统标签和医生标签数据
export function getSystemDoctorLabelList(params) {
  return req.post("/admin/label-database/getSystemDoctorLabelList", params)
}

//编链时间轴标签关联关系新增
export function saveSchemeTimeAxisDataLabel(params) {
  return req.post("/biz/scheme-time-axis-data-label", params)
}

//编链时间轴标签关联关系表删除
export function deleteSchemeTimeAxisDataLabel(id) {
  return req.delete(`/biz/scheme-time-axis-data-label/${id}`)
}
